// extracted by mini-css-extract-plugin
export default {"container":"EachUnitTable_container__tqL-D"};